export enum Event {
  acceptButtonClicked = 'acceptButtonClicked',
  dismissClicked = 'dismissClicked',
  openedPanel = 'openedPanel',
  saveButtonClicked = 'saveButtonClicked',
}

export interface Logger {
  acceptButtonClicked: () => void
  openedPanel: () => void
  saveButtonClicked: (toggle: boolean) => void
  dismissClicked: () => void
  cookieLinkClicked: () => void
  toggleClicked: (toggle: boolean) => void
  cookieLinkClickedModal: () => void
  closePanelClicked: () => void
  rendered: () => void
}

// BI catalog: https://bo.wix.com/bi-catalog-webapp/#/tickets/5eb4aa1f-a4af-477f-a71d-083eec40e56f
export interface LogObject {
  evid: number
  url: string
  toggle?: boolean
  policy?: 'cookie'
  action?: 'render | accept' | 'save' | 'settings' | 'dismiss' | 'read_policy'
}
